import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-67727235"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "resolve-item" }
const _hoisted_2 = ["onClick"]

import { ref, watchEffect } from 'vue'
import { getResolve } from '@/api/common'
import { ERR_SUCCESS } from '@/api/config'
import { ResolveConfig } from '@/types'
import { format } from 'date-fns'
import Pagination from '@/components/common/Pagination.vue'

// eslint-disable-next-line no-undef

export default /*#__PURE__*/_defineComponent({
  __name: 'ResolveList',
  props: {
    title: {},
    creator: {}
  },
  emits: ['resolveItemClicked'],
  setup(__props: any, { emit: __emit }) {

const props = __props

// eslint-disable-next-line no-undef
const emit = __emit

const dataList = ref<ResolveConfig[]>([])
const currentPage = ref<number>(1)
const pageSize = ref<number>(12)
const totalSize = ref<number>(0)

async function fetchData () {
  try {
    const params: any = {
      page: currentPage.value,
      pageSize: pageSize.value,
      status: true
    }

    if (props.creator !== 0) {
      params.creator_id = props.creator
    } else if (props.title !== '最新解析') {
      return
    }
    const {
      code,
      result: {
        items: data,
        total
      }
    } = await getResolve({ params })

    if (code === ERR_SUCCESS && data) {
      dataList.value = data
      totalSize.value = total
    }
  } catch (error) {
    console.error('Error fetching data:', error)
  }
}

watchEffect(() => {
  fetchData()
})

const handleItemClick = (item: ResolveConfig) => {
  const resolveData = {
    title: item.title,
    url: item.url,
    author: JSON.parse(item.resolve_result).author,
    course: JSON.parse(item.resolve_result).course.split('|'),
    fileList: item.resolve_url_resolve
  }
  emit('resolveItemClicked', resolveData)
}

function formatDate (dateString: string): string {
  const date = new Date(dateString)
  return format(date, 'YYYY-MM-DD')
}

return (_ctx: any,_cache: any) => {
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_text = _resolveComponent("el-text")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createBlock(_component_el_card, null, {
    default: _withCtx(() => [
      _withDirectives(_createElementVNode("div", null, [
        _createVNode(_component_el_empty, {
          "image-size": 150,
          description: "暂无数据"
        })
      ], 512), [
        [_vShow, dataList.value.length === 0]
      ]),
      _createElementVNode("div", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataList.value, (item, index) => {
          return (_openBlock(), _createElementBlock("div", { key: index }, [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(_component_el_tag, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(index + 1), 1)
                ]),
                _: 2
              }, 1024),
              _createElementVNode("div", {
                class: "item-container",
                onClick: ($event: any) => (handleItemClick(item))
              }, [
                _createVNode(_component_el_text, { truncated: "" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.title), 1)
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_component_el_tag, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(formatDate(item.update_datetime)), 1)
                  ]),
                  _: 2
                }, 1024)
              ], 8, _hoisted_2)
            ]),
            _createVNode(_component_el_divider)
          ]))
        }), 128))
      ]),
      _createVNode(Pagination, {
        "current-page": currentPage.value,
        "onUpdate:currentPage": _cache[0] || (_cache[0] = ($event: any) => ((currentPage).value = $event)),
        "page-size": pageSize.value,
        "onUpdate:pageSize": _cache[1] || (_cache[1] = ($event: any) => ((pageSize).value = $event)),
        "total-size": totalSize.value
      }, null, 8, ["current-page", "page-size", "total-size"])
    ]),
    _: 1
  }))
}
}

})